import { createApp } from 'vue'
import App from './App.vue'
import './assets/fonts.css'

createApp(App).mount('#app')
